import { Component, Input, inject } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { ButtonDefinition } from '../../models/button-definition.model';

@Component({
    selector: 'sm-message-dialog',
    templateUrl: './message-dialog.component.html',
    styleUrls: [],
    standalone: false
})
export class MessageDialogComponent {

    ref = inject(DynamicDialogRef);
    config = inject(DynamicDialogConfig);

    @Input()
    message = "";
    @Input()
    buttons: ButtonDefinition[] = [];
    @Input()
    icon = "";

    constructor() {
        this.message = this.config.data.message || "";
        this.buttons = this.config.data.buttons || [];
    }

    click(id: string): void {
        this.ref.close(id);
    }

}
